import { Link } from "react-router-dom";
import { BellRing, CheckCircle2, Clock, Landmark } from "lucide-react";
import { CALENDAR_HEARINGS, CASES, DEMO_TODAY } from "@/data/demo";

const myCaseIds = CASES.filter((c) => c.clientId === "cl1").map((c) => c.id);
const next = CALENDAR_HEARINGS
  .filter((h) => myCaseIds.includes(h.caseId) && h.date > DEMO_TODAY)
  .sort((a, b) => a.date.localeCompare(b.date))[0];

const daysAway = (date) => Math.round((new Date(`${date}T00:00:00`) - new Date(`${DEMO_TODAY}T00:00:00`)) / 86400000);

export const NextHearingCard = () => {
  if (!next) return null;
  const d = new Date(`${next.date}T00:00:00`);
  const days = daysAway(next.date);
  return (
    <div data-testid="next-hearing-card" className="mb-6 overflow-hidden rounded-3xl bg-navy shadow-xl animate-fade-up">
      <div className="flex flex-col gap-5 p-5 sm:flex-row sm:p-6">
        <div className="flex items-center gap-4 sm:flex-col sm:items-start">
          <div className="grid w-20 shrink-0 place-items-center rounded-2xl bg-gold py-3 text-white shadow-gold">
            <span className="text-[11px] font-bold uppercase tracking-wider">{d.toLocaleDateString("en-IN", { month: "short" })}</span>
            <span data-testid="next-hearing-day" className="font-heading text-3xl font-bold leading-none">{d.getDate()}</span>
            <span className="text-[11px] font-semibold">{d.toLocaleDateString("en-IN", { weekday: "short" })}</span>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-500/15 px-3 py-1 text-xs font-bold text-amber-400">
            <BellRing size={13} />In {days} {days === 1 ? "day" : "days"}
          </span>
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-xs font-semibold uppercase tracking-wider text-amber-400">Your next hearing</div>
          <Link to={`/cases/${next.caseId}`} data-testid="next-hearing-case-link" className="mt-1 block font-heading text-xl font-bold text-white hover:text-amber-200">{next.title}</Link>
          <div className="mt-3 flex flex-col gap-2 text-sm text-slate-300">
            <span className="flex items-center gap-2"><Landmark size={15} className="shrink-0 text-amber-400" /><span data-testid="next-hearing-court">{next.court}</span></span>
            <span className="flex items-center gap-2"><Clock size={15} className="shrink-0 text-amber-400" />{next.time} · Please arrive by {next.reachBy}</span>
          </div>
          <div className="mt-4 rounded-2xl bg-white/5 p-4">
            <div className="text-xs font-semibold uppercase tracking-wider text-slate-400">What to bring</div>
            <ul data-testid="next-hearing-bring-list" className="mt-2 grid gap-2 sm:grid-cols-2">
              {next.bring.map((b) => (
                <li key={b} className="flex items-start gap-2 text-sm text-white"><CheckCircle2 size={16} className="mt-0.5 shrink-0 text-emerald-400" />{b}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
